import { Button, Container, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import Display from "../../layout/Display";
import COLORS from "../../../constants/colors";
import YouTubeIcon from "../../../assets/svgs/some/youtube.svg";
import SpotifyIcon from "../../../assets/svgs/some/spotify.svg";
import ApplePodcast from "../../../assets/svgs/some/applepodcast.svg";
import Podimo from "../../../assets/svgs/some/podimo.svg";
import useIsMobile from "../../../hooks/useIsMobile";
import OkonomiAmatorene from "../../../assets/images/okonomiamatorene_3.jpg";

const PodcastStackWithFigure = () => {
  const isMobile = useIsMobile();
  return (
    <Grid
      container
      direction={{ md: "row-reverse", xs: "column" }}
      justifyContent="center"
      alignItems="center"
    >
      <Grid item md={5} paddingLeft={{ xs: "0px", md: "50px" }}>
        <Stack
          justifyContent="center"
          sx={{
            paddingBottom: { xs: "24px", md: "0px" },
            width: "100%",
          }}
        >
          <Stack
            component="img"
            src={OkonomiAmatorene}
            sx={{
              width: "100%",
              objectFit: "cover",
              borderRadius: "16px",
            }}
          />
        </Stack>
      </Grid>
      <Grid item md={6}>
        <Stack>
          <Stack spacing="24px" alignItems="flex-start">
            <Typography variant="h2" fontFamily="Erlik" color="#0F0B36">
              En Podcast om Økonomi
            </Typography>

            <Typography
              variant="body"
              color={COLORS.BLACK[100]}
              textAlign="left"
            >
              Lær økonomi av to økonomer og en standup-komiker.
            </Typography>
            <Stack
              direction={isMobile ? "column" : "row"}
              spacing="16px"
              alignItems="flex-start"
            >
              <Button
                variant="contained"
                color={isMobile ? "dark" : "light"}
                target="_blank"
                href="https://open.spotify.com/show/6hfiE0nNyxBHM6iF06UimD"
                LinkComponent="a"
              >
                <SpotifyIcon />
                <Typography
                  sx={{
                    width: { xs: "126px", md: "100%" },
                  }}
                >
                  {isMobile ? "Spotify" : "Lytt på Spotify"}
                </Typography>
              </Button>
              <Button
                variant="contained"
                color="dark"
                target="_blank"
                href="https://podimo.com/no/shows/okonomiamatorene"
                LinkComponent="a"
                sx={{ display: { xs: "normal", md: "none" } }}
              >
                <Podimo />
                <Typography
                  sx={{
                    width: "126px",
                  }}
                >
                  Podimo
                </Typography>
              </Button>
              <Button
                variant="contained"
                color="dark"
                target="_blank"
                href="https://podcasts.apple.com/us/podcast/%C3%B8konomiamat%C3%B8rene/id1521317377"
                LinkComponent="a"
                sx={{ display: { xs: "normal", md: "none" } }}
              >
                <ApplePodcast />
                <Typography
                  sx={{
                    width: "126px",
                  }}
                >
                  Apple Podcast
                </Typography>
              </Button>
              <Button
                variant="contained"
                color={isMobile ? "dark" : "light"}
                target="_blank"
                href="https://www.youtube.com/c/okonomiamatorene"
                LinkComponent="a"
              >
                <YouTubeIcon />
                <Typography
                  sx={{
                    width: { xs: "126px", md: "100%" },
                  }}
                >
                  {isMobile ? "Youtube" : "Se episodene på Youtube"}
                </Typography>
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
};

const PodcastShowCase = ({
  bgcolor = COLORS.WHITE[100],
  borderRadius,
  width,
}: {
  bgcolor?: string | undefined;
  width?: string | object;
  borderRadius?: string | undefined;
}) => {
  return (
    <Container
      sx={{
        bgcolor,
        borderRadius,
        width,
        paddingY: { xs: "22px", md: "80px" },
      }}
    >
      <Display mobile>
        <Stack justifyContent="center">
          <PodcastStackWithFigure />
        </Stack>
      </Display>
      <Display desktop>
        <PodcastStackWithFigure />
      </Display>
    </Container>
  );
};
export default PodcastShowCase;
